import { Token } from 'blueswap-sdk-core'

export class UserAddedToken extends Token {}
